const autoNgTemplateLoaderTemplate1 = require('./docker-sidebar.html');

angular.module('portainer.docker').component('dockerSidebar', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    isSidebarOpen: '<',

    endpointApiVersion: '<',
    swarmManagement: '<',
    standaloneManagement: '<',
    adminAccess: '<',
    offlineMode: '<',
    currentRouteName: '<',
    endpointId: '<',
    showStacks: '<',
  },
});
